
export enum CheckoutSteps {
  start = 'start',
  choosePayment = 'choose_payment',
  chooseMethod = 'choose_method',
  enterContact = 'enter_contact',
  chooseTime = 'choose_time',
  selectBenefit = 'select_benefit',
  review = 'review',
  submitOrder = 'submit',
  submitDemo = 'submit_demo'
}

export enum TableType {
  inhouse = 'i',
  takeout = 't',
  delivery = 'd'
}

export enum OrderMethod {
  inhouse = 'i',
  takeout = 't',
  delivery = 'd'
}

export enum DiscountType {
  General = 'general',
  Code = 'discount_code',
  Voucher = 'voucher'
}

export enum DiscountConditionType {
  Value = 'order_value',
  ValueFromGroup = 'order_value_from_group',
  OrderMethod = 'order_method',
  PaymentMethod = 'payment_method',
  Item = 'item',
  ItemFromGroup = 'item_from_group',
  Time = 'time'
}

export enum DiscountBenefitType {
  Fixed = 'fixed',
  Percentage = 'percentage',
  PercentageFromGroup = 'percentage_group',
  FreeItem = 'free_item',
  FreeItemFromGroup = 'free_item_from_group'
}

export enum OrderStatus {
  CREATED = 'Y',
  NEW = 'N',
  INPROCESS = 'O',
  CANCELED = 'C',
  DELIVERED = 'D',
  PARTIALLY_DELIVERED = 'X',
  PAID = 'P'  // not actually a real status on order, but used to indicate a paid order in host-order
}

export enum PaymentType {
  ONLINE = 'online',
  OFFLINE = 'offline'
}

export enum OrderChannel {
  HostOrder = 'host-order', // host order (authenticated)
  WaiterOrder = 'waiter-order', // waiter order (authenticated via guest-order app)
  GuestOrder = 'guest-order' // guest order (unauthenticated)
}
